"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ConditionalFields;
exports.store = void 0;
var _react = require("react");
var _redux = require("redux");
var _reducer = _interopRequireDefault(require("./reducer"));
var _action = require("./action");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var store = exports.store = (0, _redux.createStore)(_reducer.default //,
//window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
function ConditionalFields(props) {
  var [conditionFields, setconditionFields] = (0, _react.useState)([]);
  var [conditions, setconditions] = (0, _react.useState)({});
  var [fieldValues, setfieldValues] = (0, _react.useState)({});
  var [hiddenFields, sethiddenFields] = (0, _react.useState)([]);
  props.map(item => {
    var _item$fields;
    // add all items that are part of a condition or the target of an action
    buildConditions(item.model.conditionSettings.fieldConditions);
    fieldValues[item.model.conditionSettings.fieldKey] = item.model.value;
    // build conditions for any items in sections
    (_item$fields = item.fields) === null || _item$fields === void 0 || _item$fields.map(sectionItem => {
      buildConditions(sectionItem.model.conditionSettings.fieldConditions);
      fieldValues[sectionItem.model.conditionSettings.fieldKey] = item.model.value;
    });
    var handleValuesUpdate = (key, ele) => {
      var newFieldValues = fieldValues;
      if (ele.type && ele.type === 'checkbox') newFieldValues[key] = ele.checked;else newFieldValues[key] = ele.value;
      setfieldValues(newFieldValues);
    };
    if (item.valueField && typeof Element !== 'undefined') {
      var element = document.getElementById(item.valueField.id);
      if (element !== null) {
        element.onkeyup = function () {
          handleValuesUpdate(item.model.conditionSettings.fieldKey, element);
        };
        element.onchange = function () {
          handleValuesUpdate(item.model.conditionSettings.fieldKey, element);
        };
      }
    }
  });
  (0, _react.useEffect)(() => {
    // do not dispatch if there are no conditions //or form is being viewed in Experience Editor
    if (conditionFields.length) {
      store.dispatch((0, _action.updateForm)({
        conditionFields: conditionFields,
        conditions: conditions,
        fieldValues: fieldValues,
        hiddenFields: hiddenFields
      }));
    }
  }, []);
  function buildConditions(fieldConditions) {
    fieldConditions.map(fieldItem => {
      // if item is part of a condition
      fieldItem.conditions.map(conditionItem => {
        if (conditionFields.length < 1 || conditionFields.indexOf(conditionItem.fieldId) < 0) conditionFields.push(conditionItem.fieldId);
      });
      // if item is part of an action
      fieldItem.actions.map(actionItem => {
        if (conditionFields.length < 1 || conditionFields.indexOf(actionItem.fieldId) < 0) conditionFields.push(actionItem.fieldId);

        // add and arrange all conditions against a certain "action" item
        // check if that action has been defined first - then either create it or add the condition to it
        var cond = {
          matchTypeId: fieldItem.matchTypeId,
          conditions: fieldItem.conditions,
          actionTypeId: actionItem.actionTypeId
        };
        var condArr = conditions[actionItem.fieldId];
        if (typeof condArr === 'undefined') conditions[actionItem.fieldId] = [cond];else if (!condArr.some(elem => {
          return JSON.stringify(cond) === JSON.stringify(elem);
        })) conditions[actionItem.fieldId].push(cond);
      });
    });
  }
  ;
}
;